// extracted by mini-css-extract-plugin
export default {"configWindow":"invalidMagicLink_configWindow__T66q1"};